import DurationHelper from "../../../tools/DurationHelper";

export default class DashboardRunDto {

    Id: number;
    Name: string;
    PathId: number;
    PathTypeId: number;
    PathTypeLabel: string;
    PathDeleted: boolean;
    Start: Date;
    End: Date | null;
    Duration: number | null;
    Status: number;
    Progress: number;

    constructor(id: number, name: string, pathId: number, pathTypeId: number, pathTypeLabel: string, pathDeleted: boolean, start: Date, end: Date | null, status : number, progress: number) {
        this.Id = id;
        this.Name = name;
        this.PathId = pathId;
        this.PathTypeId = pathTypeId;
        this.PathTypeLabel = pathTypeLabel;
        this.PathDeleted = pathDeleted;
        this.Start = start;
        this.End = end;
        this.Duration = null;
        if (end != null) {
            this.Duration = DurationHelper.SecondsBetween(start, end);
        }
        this.Status = status;
        this.Progress = progress;
    }
}
